// platformSlice.js

import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  fetchPlatformsAsync,
  getLogicBrokerPartnersAsync,
  pollConnectedPlatformAsync,
} from "../actions/platformActions";
import { Platform } from "src/interfaces/Platform.interface";

type platformPayload={
    platformData:Platform[]| []
    platformLoading:boolean
    polledPlatformData:Platform[]| []
    logicBrokerPartnerLoading:boolean
    logicBrokerPartnerData: {
      partnerId: string
      companyName: string
      key: string
      accountType: string
    } | null

}


const initialState :platformPayload= {
  platformLoading:false,
  platformData : [],
  polledPlatformData: [],
  logicBrokerPartnerLoading: false,
  logicBrokerPartnerData: null,
};

const platformSlice = createSlice({
  name: "platformSlice",
  initialState,
   extraReducers: (builder) => {
   
    builder.addMatcher(isAnyOf(fetchPlatformsAsync.pending), (state,action)=>{
        state.platformLoading=true; 
      })
      builder.addMatcher(isAnyOf(fetchPlatformsAsync.fulfilled), (state,action)=>{
        const query = action.meta?.arg as { nature?: string; search?: string } | undefined
        const isFilteredFetch = Boolean(query?.nature || query?.search)

        if(action?.payload?.data && !isFilteredFetch){
          state.platformData = action?.payload?.data;
        }
        state.platformLoading=false; 
      })
      builder.addMatcher(isAnyOf(fetchPlatformsAsync.rejected), (state)=>{
        state.platformLoading=false; 
      })
      
      builder.addMatcher(isAnyOf(pollConnectedPlatformAsync.pending), (state,action)=>{
        state.platformLoading=true; 
      })
      builder.addMatcher(isAnyOf(pollConnectedPlatformAsync.fulfilled), (state,action)=>{
      
        state.platformLoading=false; 
        if(action?.payload?.data?.length){
          state.polledPlatformData = action?.payload?.data;
  
        }
       
      })
      builder.addMatcher(isAnyOf(pollConnectedPlatformAsync.rejected), (state)=>{
        state.platformLoading=false; 
      })

      builder.addMatcher(isAnyOf(getLogicBrokerPartnersAsync.pending), (state) => {
        state.logicBrokerPartnerLoading = true
      })
      builder.addMatcher(isAnyOf(getLogicBrokerPartnersAsync.fulfilled), (state, action: any) => {
        state.logicBrokerPartnerLoading = false
        const payloadData = action?.payload ?? null
        const sourceData =
          payloadData?.response ??
          payloadData?.data?.response ??
          payloadData?.data ??
          payloadData
        const partner = Array.isArray(sourceData)
          ? sourceData[0]
          : Array.isArray(sourceData?.results)
          ? sourceData.results[0]
          : Array.isArray(sourceData?.response)
          ? sourceData.response[0]
          : sourceData

        state.logicBrokerPartnerData = {
          partnerId: String(partner?.Id ?? partner?.id ?? '').trim(),
          companyName: String(
            partner?.CompanyName ??
              partner?.company_name ??
              partner?.Contact?.CompanyName ??
              partner?.contact?.company_name ??
              ''
          ).trim(),
          key: String(action?.meta?.arg?.key ?? '').trim(),
          accountType: String(action?.meta?.arg?.account_type ?? '').trim().toLowerCase(),
        }
      })
      builder.addMatcher(isAnyOf(getLogicBrokerPartnersAsync.rejected), (state) => {
        state.logicBrokerPartnerLoading = false
      })
      
  },
  reducers: {
    setPlatformData: (state, action: {payload: platformPayload; type: string}) => {
      state.platformLoading = action.payload?.platformLoading
      state.platformData = action.payload.platformData
    },

      
  }  
});


export const {setPlatformData} = platformSlice.actions
export default platformSlice.reducer;
